import { render } from "./recruit.vue?vue&type=template&id=71f4b9e3&scoped=true"
import script from "./recruit.vue?vue&type=script&scoped=true&lang=js"
export * from "./recruit.vue?vue&type=script&scoped=true&lang=js"

import "./recruit.vue?vue&type=style&index=0&id=71f4b9e3&scoped=true&lang=css"

import exportComponent from "D:\\Web\\hkjt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71f4b9e3"]])

export default __exports__